export default __webpack_public_path__ + "static/PC_3_5-887bfcf7d38d11f642f33781952769ed.png";